<button
  (click)="onClick()"
  [disabled]="disabled"
  [ngStyle]="{
    'background-color': bgColor,
    'color': textColor,
    'width': width,
    'height': height,
    'opacity': disabled ? '0.5' : '1',
    'cursor': disabled ? 'not-allowed' : 'pointer'
  }"
  class="custom-button"
>
  {{ label }}
</button>
